import React, { Fragment, useState, useLayoutEffect, useContext } from "react";
import { Col } from "reactstrap";
import { AlignCenter } from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { Image } from "../../../AbstractElements";
import { MENUITEMS } from "../../Sidebar/Menu";
import CustomizerContext from "../../../_helper/Customizer";
import NotificationSlider from "./NotificationSlider";
import { useSelector } from "react-redux";

const Leftbar = () => {
  const { layoutURL, setToggleIcon, toggleSidebar } =
    useContext(CustomizerContext);
  const [sidebartoggle, setSidebartoggle] = useState(true);
  const width = useWindowSize();
  const baseurl = useSelector((store) => store.baseUrl);
  const [userdetails, setUserdetails] = useState(
    JSON.parse(localStorage.getItem("userdetails"))
  );

  const sidebarItemCount = MENUITEMS.reduce(
    (n, block) => n + (Array.isArray(block.Items) ? block.Items.length : 0),
    0
  );

  const location = useLocation();
  const pathSegs = location.pathname.replace(/\/+$/, "").split("/").filter(Boolean);
  const hideHeaderSidebarToggle =
    pathSegs[pathSegs.length - 1] === "dashboardpos";

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
        if (window.innerWidth <= 991) {
          setToggleIcon(true);
        } else {
          setToggleIcon(false);
        }
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  const responsive_openCloseSidebar = (toggle) => {
    if (width <= 991) {
      toggleSidebar(!toggle);
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper ";
      document.querySelector(".bg-overlay1").classList.add("active");
    } else {
      if (toggle) {
        toggleSidebar(!toggle);
        document.querySelector(".sidebar-wrapper").className =
          "sidebar-wrapper close_icon ";
      } else {
        toggleSidebar(!toggle);
        document.querySelector(".sidebar-wrapper").className =
          "sidebar-wrapper ";
      }
    }
  };

  function getDashboardLink() {
    const IS_POS = process.env.REACT_APP_IS_POS;
    switch (IS_POS) {
      case "0":
        return `${process.env.PUBLIC_URL}/timesheetportal`;
      case "1":
        return `${process.env.PUBLIC_URL}/dashboardposmain`;
      case "3":
        return `${process.env.PUBLIC_URL}/dashboard`;
      default:
        return `${process.env.PUBLIC_URL}/dashboard`; // Default to /dashboard if IS_POS is not 0, 1, or 3
    }
  }

  return (
    <Fragment>
      <Col className="header-logo-wrapper col-auto p-0 flex-shrink-0" id="out_side_click">
        <div className="logo-wrapper">
          {/* <Link to={`${process.env.PUBLIC_URL}/dashboard/default/${layoutURL}`}>
            <Image
              attrImage={{
                className: "img-fluid for-light",
                src: `${require("../../../assets/images/logo/logo.png")}`,
                alt: "",
              }}
            />
            <Image
              attrImage={{
                className: "img-fluid for-dark",
                src: `${require("../../../assets/images/logo/logo_dark.png")}`,
                alt: "",
              }}
            />
          </Link> */}
          <Link to={getDashboardLink()}>
            <Image
              attrImage={{
                className: "d-inline",
                src: `${baseurl}/${userdetails?.company_logo}`,
                alt: "",
                style: {
                  height: "60px",
                  maxWidth: "100%",
                },
              }}
            />
          </Link>
        </div>
        {sidebarItemCount > 0 && !hideHeaderSidebarToggle && (
        <div
          className="toggle-sidebar"
          onClick={() => responsive_openCloseSidebar(sidebartoggle)}
          style={
            window.innerWidth <= 991
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <AlignCenter
            className="status_toggle middle sidebar-toggle"
            id="sidebar-toggle"
          />
        </div>
        )}
      </Col>
      {/* <Col xxl="5" xl="6" lg="5" md="4" sm="3" className="left-header p-0">
        <NotificationSlider />
      </Col> */}
    </Fragment>
  );
};

export default Leftbar;
